export const HALAL_CHECK_DEFINITIONS = [
  {
    id: 'halal_certificate_provided',
    title: 'Halal Certificate Provided',
    source: 'Input',
    defaultSeverity: 'high',
    detailMissing: 'No Halal certificate uploaded for verification',
    detailPass: 'Halal certificate uploaded for verification',
    fix: 'Obtain valid Halal certificate from accredited body',
  },
  {
    id: 'certificate_expiry_valid',
    title: 'Certificate Validity / Expiry',
    source: 'N/A',
    defaultSeverity: 'medium',
    detailMissing: 'Cannot verify — certificate not provided',
    detailPass: 'Certificate present — verify expiry dates manually',
    fix: 'Ensure certificate covers production dates',
  },
  {
    id: 'issuing_body_listed',
    title: 'Issuing Body Listed',
    source: 'N/A',
    defaultSeverity: 'medium',
    detailMissing: 'Cannot verify accreditation status',
    detailPass: 'Issuing body detected — confirm recognition for target market',
    fix: 'Confirm issuing body recognized by target market',
  },
  {
    id: 'animal_derived_ingredient_risk',
    title: 'Animal-Derived Ingredient Risk',
    source: 'TDS',
    defaultSeverity: 'medium',
    detailMissing: 'Animal-derived ingredients detected — source verification required',
    detailPass: 'No animal-derived ingredients detected in available documents',
    fix: 'Confirm dairy/meat sources meet Halal requirements',
  },
  {
    id: 'gelatin_enzymes_check',
    title: 'Gelatin / Enzymes Check',
    source: 'TDS',
    defaultSeverity: 'low',
    detailMissing: 'Gelatin or animal enzymes detected — verify source',
    detailPass: 'No gelatin or animal enzymes declared',
    fix: 'Confirm gelatin/enzymes are Halal-compliant or remove',
  },
  {
    id: 'alcohol_solvent_carrier_flags',
    title: 'Alcohol / Solvent Carrier Flags',
    source: 'TDS',
    defaultSeverity: 'medium',
    detailMissing: 'Flavourings detected — carrier not specified',
    detailPass: 'No alcohol or solvent carriers detected',
    fix: 'Confirm non-alcohol carrier with supplier',
  },
  {
    id: 'e_number_source_verification',
    title: 'E-Number Source Verification',
    source: 'Label',
    defaultSeverity: 'medium',
    detailMissing: 'E-numbers detected — verify sources',
    detailPass: 'No high-risk E-numbers detected',
    fix: 'Request Halal statement from E-number suppliers',
  },
  {
    id: 'cross_contamination_statement',
    title: 'Cross-Contamination Statement',
    source: 'TDS',
    defaultSeverity: 'high',
    detailMissing: 'No dedicated line / cleaning protocol info',
    detailPass: 'Cross-contamination controls documented',
    fix: 'Obtain facility Halal compliance statement',
  },
  {
    id: 'traceability_fields_complete',
    title: 'Traceability Fields Complete',
    source: 'TDS',
    defaultSeverity: 'low',
    detailMissing: 'Traceability details not found',
    detailPass: 'Lot traceability documented',
    fix: 'Ensure lot traceability is documented',
  },
  {
    id: 'halal_logo_usage_check',
    title: 'Halal Logo Usage Check',
    source: 'Label',
    defaultSeverity: 'medium',
    detailMissing: 'No Halal logo present on label',
    detailPass: 'Halal logo detected — verify authorization',
    fix: 'Add authorized logo only with valid certification',
  },
];
